import React, { useCallback } from 'react'
import {Button} from 'react-bootstrap'
import { useIntl } from 'react-intl'
import {useNavigate} from 'react-router-dom'
/**
 * NotPermission - A component displayed when user lacks access permissions
 *
 * @component
 * @description Renders a full-page overlay indicating insufficient permissions
 *
 * @param {string} [message] - Optional custom message from backend to display instead of default text
 *
 * @returns {React.ReactElement} Permission denied interface
 *
 * @remarks
 * - Uses react-router-dom for navigation
 * - Supports internationalization via react-intl
 *
 * @example
 * <NotPermission />
 * <NotPermission message="Custom error message from backend" />
 */
export default function NotPermission ({ message }: { message?: string }) {
  const navigate = useNavigate()
  const intl = useIntl()
  const closeAllModals = useCallback(() => {
    // Get all modal backdrop elements
    const backdrops = document.querySelectorAll('.modal-backdrop');
    
    // Remove all backdrop elements
    backdrops.forEach(backdrop => {
      backdrop.remove();
    });
    
    // Get all modal elements
    const modals = document.querySelectorAll('.modal');
    
    // For each modal
    modals.forEach(modal => {
      // Remove the 'show' class
      modal.classList.remove('show');
      
      // Remove inline styles (Bootstrap adds display: block)
      (modal as HTMLElement).style.display = 'none';
      
      // Remove the 'modal-open' class from body to enable scrolling
      document.body.classList.remove('modal-open');
      
      // Remove the aria-modal attribute
      modal.setAttribute('aria-modal', 'false');
      
      // Set aria-hidden to true
      modal.setAttribute('aria-hidden', 'true');
    });
    
    // Remove any padding-right added to the body
    document.body.style.paddingRight = '';
    
    // Enable scrolling
    document.body.style.overflow = '';
  }, []);
  return (
    <div
      className='position-absolute d-flex justify-content-center m-0 p-0 w-100 h-100 mw-100'
      style={{
        zIndex: 99,
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        className='position-sticky d-flex flex-column align-items-center gap-10 p-10 card'
        style={{
          height: 'fit-content',
          width: '70%',
          maxWidth: 600,
          minWidth: 400,
          backgroundColor: '#76767670',
          top: 90,
        }}
      >
        <h1 className='text-center fw-bold'>
          {message || intl.formatMessage({id: 'You do not have the necessary permissions to view this page or use this feature'})}
        </h1>
        <Button
          onClick={() => {
            closeAllModals()
            navigate('/select-organization')
          }}
        >
          {intl.formatMessage({id: 'Switch to another organization'})}
          
        </Button>
      </div>
    </div>
  )
}
